
    import 'regenerator-runtime';
    import {configure} from '@storybook/react';
    import {
      addDecorator,
      addParameters,
      addLoader,
      addArgTypesEnhancer,
      addArgsEnhancer
    } from '@storybook/client-api';
    import { logger } from '@storybook/client-logger';
    import * as stories from '../../**/stories/*.stories.{js,jsx,ts,tsx}';
    import * as config_0 from '../../../node_modules/@storybook/react/dist/esm/client/docs/config';
import * as config_1 from '../../../node_modules/@storybook/react/dist/esm/client/preview/config';
import * as config_2 from '../../../node_modules/@storybook/addon-actions/preview.js';
import * as config_3 from '../../../node_modules/@storybook/addon-a11y/preview.js';
import * as config_4 from '../../../.storybook/preview.js';
    let configs = [config_0,config_1,config_2,config_3,config_4];

    configs.forEach(config => {
      Object.keys(config).forEach((key) => {
        const value = config[key];
        switch (key) {
          case 'args':
          case 'argTypes': {
            return logger.warn('Invalid args/argTypes in config, ignoring.', JSON.stringify(value));
          }
          case 'decorators': {
            return value.forEach((decorator) => addDecorator(decorator, false));
          }
          case 'loaders': {
            return value.forEach((loader) => addLoader(loader, false));
          }
          case 'parameters': {
            return addParameters({ ...value }, false);
          }
          case 'argTypesEnhancers': {
            return value.forEach((enhancer) => addArgTypesEnhancer(enhancer));
          }
          case 'argsEnhancers': {
            return value.forEach((enhancer) => addArgsEnhancer(enhancer))
          }
          case 'globals':
          case 'globalTypes': {
            const v = {};
            v[key] = value;
            return addParameters(v, false);
          }
          case 'decorateStory':
          case 'renderToDOM':
          case 'render': {
            return null; // This key is not handled directly in v6 mode.
          }
          default: {
            // eslint-disable-next-line prefer-template
            return console.log(key + ' was not supported :( !');
          }
        }
      });
    });

    let keyMap = {};
    function walk(obj, key) {
      for (let k in obj) {
        if (k === 'tsx' || k === 'ts' || k === 'js' || k === 'jsx') {
          keyMap[key + '.' + k] = obj[k];
        } else {
          walk(obj[k], (key ? key + '/' : '') + k);
        }
      }
    }

    walk(stories);

    function context(key) {
      return keyMap[key];
    }

    context.keys = () => Object.keys(keyMap);
    context.resolve = (key) => key;

    configure(context, module, false);
  